import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBullseye, faClipboardCheck, faExchangeAlt, faHome, faSync, faThLarge } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";
import { faAddressCard } from "@fortawesome/free-solid-svg-icons";
import { faWallet } from "@fortawesome/free-solid-svg-icons";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import { faStickyNote } from "@fortawesome/free-solid-svg-icons";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { faUserCog } from "@fortawesome/free-solid-svg-icons";
import { faToolbox } from "@fortawesome/free-solid-svg-icons";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faCartPlus } from "@fortawesome/free-solid-svg-icons";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faMinusSquare } from "@fortawesome/free-solid-svg-icons";
import { faMoneyCheck } from "@fortawesome/free-solid-svg-icons";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { faShoppingBag } from "@fortawesome/free-solid-svg-icons";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";
import { faVolumeDown } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faStore } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { faSmile } from "@fortawesome/free-solid-svg-icons";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { faPoll } from "@fortawesome/free-solid-svg-icons";
import { faDumpster } from "@fortawesome/free-solid-svg-icons";
import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { faProjectDiagram, faDiagramProject } from "@fortawesome/free-solid-svg-icons";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faBoxes, faExclamationCircle, faSitemap, faCheck, faBan } from '@fortawesome/free-solid-svg-icons';
import { faChartLine, faUserMinus, faShareAlt, faTimesCircle, faCalendarTimes } from '@fortawesome/free-solid-svg-icons';
import { faFileInvoice, faFileInvoiceDollar, faMoneyBillWave, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { faUserShield, faBuilding, faImage, faBox } from '@fortawesome/free-solid-svg-icons';
import { faDollarSign, faTags, faPercent, faLayerGroup, faFileAlt, faBalanceScale } from '@fortawesome/free-solid-svg-icons';
import { faCalendar, faCashRegister, faShoppingBasket, faPlusCircle, faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft, faSlidersH, faUndo, faHandHoldingUsd, faChartPie, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { faLandmark, faShieldAlt, faPiggyBank, faLightbulb, faPaperPlane, faMinusCircle, faList } from '@fortawesome/free-solid-svg-icons';
import { faCopy, faHistory, faTag, faArrowTrendDown, faArrowTrendUp, faCubes, faCube } from '@fortawesome/free-solid-svg-icons';
import { faTrophy, faArrowDown, faPhone, faUniversity, faClock, faTruck, faFileExcel, faSpinner, faUpload } from "@fortawesome/free-solid-svg-icons";
import { faInfoCircle, faCalendarAlt, faUserCircle, faComment, faComments, faLifeRing } from '@fortawesome/free-solid-svg-icons';
import { faArrowRight, faEnvelopeOpenText, faChevronUp, faChevronDown, faSignInAlt, faUserEdit, faToggleOn, faToggleOff} from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft, faBellSlash, faCalendarWeek, faUmbrellaBeach, faCalendarCheck, faBirthdayCake, faBullhorn } from '@fortawesome/free-solid-svg-icons';
import { faCalendarDay, faHeart, faCommentDots, faUserCheck, faPoundSign, faNairaSign, faIdBadge, faMoneyCheckAlt, faTrashAlt, faTools } from '@fortawesome/free-solid-svg-icons';
import { faMicrophone, faStop, faDownload, faFile, faFilePdf, faFileWord, faFilePowerpoint, faFileArchive, faFileVideo, faReply, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { faMoon, faHourglassHalf, faTable, faCheckDouble, faUserSlash, faGlobe, faMap, faCity, faMailBulk, faIdCard } from '@fortawesome/free-solid-svg-icons';
import { faExternalLinkAlt, faLink, faSave, faFileCsv, faGauge, faBook, faUsersCog, faPlug, faStar, faTicketAlt, faFileImage } from '@fortawesome/free-solid-svg-icons';
import { faPrint, faRedo, faUserTie, faBriefcase, faFileUpload, faTasks, faPenAlt, faFolderOpen, faWater, faRocket } from '@fortawesome/free-solid-svg-icons';
import { faFilter, faClipboardList, faHandshake, faFileContract, faTruckLoading, faMedal, faKey, faAddressBook } from '@fortawesome/free-solid-svg-icons';
import { faRoute, faPlay, faPause, faFolderPlus, faArchive, faCertificate, faPlayCircle, faCalendarPlus, faGraduationCap, faAward, faUserClock } from '@fortawesome/free-solid-svg-icons';
import { faQrcode, faDoorOpen, faWalking, faColumns, faFileSignature, faQuestionCircle, faMagic, faForward, faUserTimes, faFileExport } from "@fortawesome/free-solid-svg-icons";
import { faUserFriends, faBolt, faPencilAlt, faHardHat, faFileImport, faLockOpen, faCode, faInbox } from "@fortawesome/free-solid-svg-icons";

library.add(faFileInvoice, faFileInvoiceDollar, faMoneyBillWave, faSyncAlt, faBan);

library.add(faBoxes, faExclamationCircle, faSitemap, faCheck);
library.add(faChartLine, faUserMinus, faShareAlt, faTimesCircle, faCalendarTimes);
library.add(faChevronRight);
library.add(faAngleRight);
library.add(faUserShield, faBuilding, faImage, faBox);
library.add(faDollarSign, faTags, faPercent, faLayerGroup, faFileAlt, faBalanceScale);
library.add(faCalendar, faCashRegister, faShoppingBasket, faPlusCircle, faCheckCircle, faTimes);
library.add(faArrowLeft, faExchangeAlt, faSlidersH, faUndo, faHandHoldingUsd, faChartPie, faArrowUp);
library.add(faLandmark, faShieldAlt, faPiggyBank, faLightbulb, faPaperPlane, faMinusCircle, faList );
library.add(faCopy, faHistory, faTag, faArrowTrendDown, faArrowTrendUp, faCubes, faCube);
library.add(faTrophy, faArrowDown, faPhone, faUniversity, faClock, faTruck, faFileExcel, faSpinner, faUpload);
library.add(faInfoCircle, faCalendarAlt, faUserCircle, faComment, faComments, faLifeRing);
library.add(faArrowRight, faEnvelopeOpenText, faChevronUp, faChevronDown, faSignInAlt, faUserEdit, faThLarge, faToggleOn, faToggleOff);
library.add(faChevronLeft, faBellSlash, faCalendarWeek, faUmbrellaBeach, faCalendarCheck, faBirthdayCake, faBullhorn);
library.add(faCalendarDay, faHeart, faCommentDots, faUserCheck, faPoundSign, faNairaSign, faIdBadge, faMoneyCheckAlt, faTrashAlt, faTools);
library.add(faMicrophone, faStop, faDownload, faFile, faFilePdf, faFileWord, faFilePowerpoint, faFileArchive, faFileVideo, faReply, faPaperclip);
library.add(faMoon, faHourglassHalf, faTable, faCheckDouble, faUserSlash, faGlobe, faMap, faCity, faMailBulk, faIdCard);
library.add(faExternalLinkAlt, faLink, faSave, faFileCsv, faGauge, faBook, faUsersCog, faPlug, faStar, faTicketAlt, faFileImage);
library.add(faPrint, faRedo, faUserTie, faBriefcase, faFileUpload, faTasks, faPenAlt, faFolderOpen, faWater, faRocket);
library.add(faFilter, faClipboardList, faHandshake, faFileContract, faBullseye, faClipboardCheck, faSync, faTruckLoading, faMedal, faKey, faAddressBook);
library.add(faRoute, faPlay, faPause, faFolderPlus, faArchive, faCertificate, faPlayCircle, faCalendarPlus, faGraduationCap, faAward, faUserClock);
library.add(faQrcode, faDoorOpen, faWalking, faColumns, faFileSignature, faQuestionCircle, faMagic, faForward, faUserTimes, faFileExport );
library.add(faUserFriends, faBolt, faPencilAlt, faHardHat, faFileImport, faLockOpen, faCode, faInbox);

library.add(faHome);
library.add(faUser);
library.add(faBars);
library.add(faChartBar);
library.add(faAddressCard);
library.add(faWallet);
library.add(faCalculator);
library.add(faStickyNote);
library.add(faCreditCard);
library.add(faCog);
library.add(faClipboard);
library.add(faSignOutAlt);
library.add(faLongArrowAltDown);
library.add(faShoppingCart);
library.add(faBell);
library.add(faUserCog);
library.add(faToolbox);
library.add(faSearch);
library.add(faPen);
library.add(faTrash);
library.add(faCartPlus);
library.add(faUserPlus);
library.add(faPlus);
library.add(faEye);
library.add(faMinusSquare);
library.add(faMoneyCheck);
library.add(faUsers);
library.add(faShoppingBag);
library.add(faCoins);
library.add(faReceipt);
library.add(faVolumeDown);
library.add(faEdit);
library.add(faStore);
library.add(faEnvelope);
library.add(faMapMarkerAlt);
library.add(faPhoneAlt);
library.add(faLock);
library.add(faSmile);
library.add(faSort);
library.add(faBookOpen);
library.add(faPoll);
library.add(faDumpster);
library.add(faBarcode);
library.add(faEllipsisV);
library.add(faProjectDiagram);
library.add(faDiagramProject);
library.add(faExclamationTriangle);
library.add(faAngleLeft);
library.add(faCamera);
library.add(faCircle);
library.add(faEyeSlash);

export default FontAwesomeIcon;
